import { RegexBasedPasswordPolicy } from './RegexBasedPasswordPolicy';

export class MustContainLettersPolicy extends RegexBasedPasswordPolicy {

    private static instance: MustContainLettersPolicy = new MustContainLettersPolicy();

    private constructor() {
        super(/[a-zA-Z]/);
    }

    public static getPolicy(): MustContainLettersPolicy {
        return MustContainLettersPolicy.instance;
    }
}
